import { render, staticRenderFns } from "./ArticleRec.vue?vue&type=template&id=23b73d92&scoped=true&"
import script from "./ArticleRec.vue?vue&type=script&lang=js&"
export * from "./ArticleRec.vue?vue&type=script&lang=js&"
import style0 from "./ArticleRec.vue?vue&type=style&index=0&id=23b73d92&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b73d92",
  null
  
)

export default component.exports